import { z } from 'zod';

export const sentooWebhookResponseSchema = z.object({
  received: z.literal(true),
  processed: z.boolean(),
});
export type SentooWebhookResponse = z.infer<typeof sentooWebhookResponseSchema>;
